var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgQtVideo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M161.222 56.148a20.847 20.847 0 0 1 20.848 20.848v125.782c0 11.513-9.334 20.847-20.848 20.847H35.44c-11.513 0-20.847-9.334-20.847-20.847V76.996c0-11.514 9.334-20.848 20.847-20.848zm82.605 16.443c9.29-6.368 21.981.174 21.981 11.252v112.026c0 11.122-12.735 17.62-21.981 11.252l-47.8-32.928v-68.648z"
})));
export default SvgQtVideo;